import { render, staticRenderFns } from "./UiIconButton.vue?vue&type=template&id=52427a7f"
import script from "./UiIconButton.vue?vue&type=script&lang=js"
export * from "./UiIconButton.vue?vue&type=script&lang=js"
import style0 from "./UiIconButton.vue?vue&type=style&index=0&id=52427a7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports